import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import {
  DatePicker,
  DesktopDatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../actions/alert";
import {
  createCrmLeadFollowUp,
  getCrmFollowUpList,
} from "../../../api/crmLeads";
import { createLeadFollowUp } from "../../../api/partnerLead";
import { getFollowUpList } from "../../../api/sales";
import ControlledTable from "../../../component/ControlledTable";
import { handleAxiosError } from "../../../config/action-config";
import { followUpListTable as tableDef } from "../../../config/grid-columns-defs";

export default function ViewCrmLeadsFollowup({ leadId }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [itemDialog, setItemDialog] = useState(false);

  const getRows = async (numRows, startRow) => {
    return getCrmFollowUpList(
      { lead_id: leadId, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getCrmFollowUpList(
        { lead_id: leadId, limit: 10, offset: 0 },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  const onItemDialogSubmit = async (postData) => {
    postData.lead_id = leadId;
    try {
      const { data } = await createCrmLeadFollowUp(postData, user.token);
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <div>
      <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setItemDialog(true);
          }}
          className="blue-button"
        >
          Add Follow Up
        </Button>
      </Box>

      <div className="ag-theme-material" style={{ height: "300px" }}>
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
      <ItemDialogFollowUpTab
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
    </div>
  );
}
const emptyItemData = {
  lead_id: "",
  description: "",
  follow_date: "",
  activity: "",
};
function ItemDialogFollowUpTab({ open, setOpen, onSubmit }) {
  const user = useSelector((state) => state.user);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyItemData });

  const submit = (data) => {
    onSubmit(data);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Lead Follow Up
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl required fullWidth error={Boolean(errors.follow_date)}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DesktopDatePicker
                      value={props.value || ""}
                      shouldDisableDate={disablePrevDates(
                        dayjs(new Date()).subtract(1, "days").toJSON()
                      )}
                      label="Follow Up On"
                      onChange={(nv) => {
                        props.onChange(nv.toLocaleDateString());
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          error={Boolean(errors.follow_date)}
                          {...params}
                        />
                      )}
                    />
                  )}
                  rules={{
                    required: "Follow Up is required",
                  }}
                  name="follow_date"
                  control={control}
                />
              </LocalizationProvider>
              <FormHelperText>{errors.follow_date?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              type="text"
              label="Activity"
              name="activity"
              fullWidth
              inputRef={register({
                required: "Activity is required.",
              })}
              required
              error={Boolean(errors.activity)}
              helperText={errors.activity?.message}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              type="text"
              label="Description"
              name="description"
              fullWidth
              multiline={true}
              rows={3}
              inputRef={register({
                required: "Description is required.",
              })}
              required
              error={Boolean(errors.description)}
              helperText={errors.description?.message}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          className="blue-button"
          onClick={handleSubmit(submit)}
        >
          {"Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
